var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.0013 10.074L10.6063 12.2498L9.64964 8.149L12.8346 5.38984L8.64047 5.034L7.0013 1.1665L5.36214 5.034L1.16797 5.38984L4.35297 8.149L3.3963 12.2498L7.0013 10.074Z","fill":"#FFD700"}));
}

Star.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Star;

Star.default = Star;
